import Vue from 'vue'
import VueRouter from 'vue-router'
import Login from '../views/login.vue'

Vue.use(VueRouter)

const routes = [
  {
  	path: "/",
  	redirect: "/login"
  },
  {
  	path: "/login", //登录页
  	name: "Login",
  	component: () =>import("../views/login.vue")
  },
  {
  	path: "/loginV", //登录页
  	name: "LoginV",
  	component: () =>import("../views/login-v.vue")
  },
  {
  	path: "/goods",
  	name: "Goods",
  	component: () =>import("../views/goods/index.vue")
  },
  {
  	path: "/index", //首页
  	name: "Index",
  	component: () =>import("../views/index/index.vue")
  },
  {
	path: "/cart", //购物车
	name: "Cart",
	component: () =>import("../views/cart/index.vue")
  },
  {
  	path: "/order", //订单首页
  	name: "Order",
  	component: () =>import("../views/order/index.vue")
  },
  {
	path: "/appraise", //订单评价
	name: "Appraise",
	component: () =>import("../views/order/appraise.vue")
},
  {
	path: "/orderdetail", //订单详情
	name: "Orderdetail",
	component: () =>import("../views/order/orderdetail.vue")
  },
  {
  	path: "/promotion", //促销详情
  	name: "Promotion",
  	component: () =>import("../views/promotion/index.vue")
  },
  {
  	path: "/notice", //公告主页
  	name: "Notice",
  	component: () =>import("../views/notice/index.vue")
  },
  {
  	path: "/noticeDetail", //公告详情
  	name: "NoticeDetail",
  	component: () =>import("../views/notice/noticeDetail.vue")
  },
  {
	path: "/personal", //个人中心
	name: "Personal",
	component: () =>import("../views/personal/index.vue")
  },
  {
  	path: "/message", //消息主页
  	name: "Message",
  	component: () =>import("../views/message/index.vue")
  },
  {
  	path: "/msgDetail", //消息详情
  	name: "MsgDetail",
  	component: () =>import("../views/message/msgDetail.vue")
  },
  {
  	path: "/coupon", //优惠券主页
  	name: "Coupon",
  	component: () =>import("../views/coupon/index.vue")
  },
  {
    path: "/placeanorder", //预订单
    name: "Placeanorder",
    component: () =>import("../views/cart/placeanorder.vue")
  },
  {
    path: "/paymoney", //支付
    name: "Paymoney",
    component: () =>import("../views/cart/paymoney.vue")
  },
  {
    path: "/detailist", //商品清单
    name: "Detailist",
    component: () =>import("../views/cart/detailist.vue")
  },
  {
  	path: "/proList", //促销活动列表
  	name: "ProList",
  	component: () =>import("../views/proList/index.vue")
  },
  {
  	path: "/quick", //快速补货
  	name: "Quick",
  	component: () =>import("../views/quick/index.vue")
  },
  {
  	path: "/detail", //商品详情
  	name: "Detail",
  	component: () =>import("../views/detail/index.vue")
  },
  {
  	path: "/myCoupon", //我的优惠券详情
  	name: "MyCoupon",
  	component: () =>import("../views/coupon/myCoupon.vue")
  },
  {
  	path: "/store", //店铺
  	name: "Store",
  	component: () =>import("../views/store/index.vue")
  },
  {
  	path: "/merchantGroup", //店铺
  	name: "MerchantGroup",
  	component: () =>import("../views/store/merchantGroup.vue")
  },
  {
  	path: "/certification", //店铺资质
  	name: "Certification",
  	component: () =>import("../views/certification/index.vue")
	},
	{
  	path: "/bulkImport", //批量导入
  	name: "BulkImport",
  	component: () =>import("../views/bulkImport/index.vue")
  },
]
const router = new VueRouter({
	// base: '/client/',
	routes,
	mode: "hash" // mode 设置为history ，去掉地址栏上的 # 号  hash
});


export default router;



// WEBPACK FOOTER //
// ./src/router/index.js